var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFileUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#888",
  d: "M6.753 10.5a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#888",
  d: "M18 21a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h8.25L18 6.75zM3 1.5A1.5 1.5 0 0 0 1.5 3v15l3.336-3.336a.75.75 0 0 1 .915-.112L9 16.5l3.236-4.53a.75.75 0 0 1 1.14-.095L16.5 15V6.75h-3a2.25 2.25 0 0 1-2.25-2.25v-3z"
})));
export default SvgFileUpload;